import type { IconProps } from '__components/Kizen/Icon';
import type { Placement } from 'react-bootstrap/Overlay';
import styled from '@emotion/styled';
import Icon from 'components/Kizen/Icon';
import { useTooltip } from '__components/Kizen/Tooltip';

interface IconWithTooltipProps extends Omit<IconProps, 'icon'> {
  icon?: string;
  iconSize?: string;
  label: string;
  placement?: Placement;
}

const InfoIcon = styled(Icon)<
  Omit<IconWithTooltipProps, 'label' | 'placement'>
>`
  & svg {
    width: ${({ iconSize }) => iconSize || '10px'};
    height: ${({ iconSize }) => iconSize || '10px'};
  }
`;

export const IconWithTooltip = (props: IconWithTooltipProps) => {
  const {
    label,
    icon = 'info-circle',
    iconSize,
    placement = 'top',
    className = '',
    ...rest
  } = props;

  const [tooltipProps, tooltip] = useTooltip({
    label,
    placement,
  });

  return (
    <>
      <InfoIcon
        icon={icon}
        iconSize={iconSize}
        {...tooltipProps}
        className={className}
        {...rest}
      />
      {tooltip}
    </>
  );
};
